// common/services/competition/cloneCompetition.ts
import req from '../../api/request'
import type { CloneCompetitionRequest } from '../../features/competition/wizard/types'

export type ClonedCompetition = {
  id: string
  name_full: string
  is_tournament: boolean
  starts_at: string
  ends_at: string
}

export const cloneCompetition = async (
  sourceScheduleId: string,
  body: CloneCompetitionRequest
): Promise<ClonedCompetition> => {
  const response = await req(`/schedules/${sourceScheduleId}/clone`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
  return response.data as ClonedCompetition
}
